export function hasInPersonNavigation(coachingType: string | null | undefined, selfDirected: boolean) {
  return !selfDirected && ['one_on_one', 'semi_private', 'hybrid'].includes(coachingType ?? '');
}
export function clientBottomTargets(userId: number, _inPerson: boolean) {
  return [
    { path: '/client', label: 'Home', icon: 'home' },
    { path: '/client/training', label: 'Training', icon: 'training' },
    { path: '/client/nutrition', label: 'Nutrition', icon: 'nutrition' },
    { path: '/client/community', label: 'Community', icon: 'community' },
    { path: `/client/members/${userId}`, label: 'Me', icon: 'me' },
  ];
}
/** iPhone tab bar: four route tabs, then More (a button that opens the More
 * page, where Community, Messages, Journal, the profile, and everything else
 * live). iPad keeps clientBottomTargets above. */
export type ClientPhoneTab = { path: string; label: string; icon: 'today' | 'training' | 'nutrition' | 'faith' };
export function clientPhoneTabs(): ClientPhoneTab[] {
  return [
    { path: '/client', label: 'Today', icon: 'today' },
    { path: '/client/training', label: 'Training', icon: 'training' },
    { path: '/client/nutrition', label: 'Nutrition', icon: 'nutrition' },
    { path: '/client/faith', label: 'Faith', icon: 'faith' },
  ];
}
const TRAINING_PATHS = ['/client/training', '/client/week', '/client/workout', '/client/program', '/client/programs', '/client/history', '/client/exercises'];
const FAITH_PATHS = ['/client/faith', '/client/devotional', '/client/bible', '/client/word-study', '/client/divine-mandate', '/client/reading-plans', '/client/coach-playlists'];
export function clientTabActive(path: string, location: string) {
  const current = location.split('?')[0];
  if (path === '/client') return current === '/client';
  if (path === '/client/community' && current.startsWith('/community/groups/')) return true;
  if (path === '/client/training') return TRAINING_PATHS.some(p => current === p || current.startsWith(`${p}/`));
  if (path === '/client/faith') return FAITH_PATHS.some(p => current === p || current.startsWith(`${p}/`));
  return current === path || current.startsWith(`${path}/`);
}
/** On the phone, any route outside the four route tabs belongs to More. */
export function clientPhoneMoreActive(location: string) {
  return !clientPhoneTabs().some(tab => clientTabActive(tab.path, location));
}
